import React from "react";

export const Logo = ({ size = "default" }) => {
  const sizes = {
    small: { box: "h-9 w-9", mk: "text-base", text: "text-[10px]" },
    default: { box: "h-11 w-11", mk: "text-xl", text: "text-[11px]" },
    large: { box: "h-16 w-16", mk: "text-3xl", text: "text-base" },
  };
  const s = sizes[size] || sizes.default;

  return (
    <div className="flex items-center gap-3" data-testid="mk-logo">
      <div className={`relative ${s.box} flex items-center justify-center`}>
        {/* Shield/badge */}
        <div className="absolute inset-0 rotate-45 bg-[#FFD600] rounded-md" />
        <div className="absolute inset-[2px] rotate-45 bg-[#0A0A0A] rounded-md" />
        <span className={`relative font-heavy ${s.mk} text-[#FFD600] tracking-tight`}>
          MK
        </span>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display ${size === "large" ? "text-3xl" : "text-xl"} text-white tracking-wider`}>
          MK REMORQUAGE
        </span>
        <span className={`${s.text} text-[#FFD600] font-bold uppercase tracking-[0.25em] mt-0.5`}>
          24/7 · Perpignan
        </span>
      </div>
    </div>
  );
};

export default Logo;
